export interface FAQItem {
  question: string;
  answer: string;
}

export interface PageSeoConfig {
  title?: string;
  titleKey?: string;
  description?: string;
  descriptionKey?: string;
  ogTitle?: string;
  ogTitleKey?: string;
  ogDescription?: string;
  ogDescriptionKey?: string;
  ogImage: string;
  faqs?: (t: (key: string) => string) => FAQItem[];
}

export const PAGES_SEO = {
  // 1. Homepage SEO & FAQs
  home: {
    title: 'E-School Cambodia - គេហទំព័រសម្រាប់រៀនបន្ថែមត្រៀមប្រឡងបាក់ឌុបតាមអនឡាញ',
    ogTitle: 'E-School Cambodia',
    description:
      'គេហទំព័រសម្រាប់រៀនបន្ថែមត្រៀមប្រឡងបាក់ឌុបតាមអនឡាញ (Online Learning Platform for Bac II Exam Preparation)',
    ogDescription:
      'គេហទំព័រសម្រាប់រៀនបន្ថែមត្រៀមប្រឡងបាក់ឌុបតាមអនឡាញ (Online Learning Platform for Bac II Exam Preparation)',
    ogImage: '/img/homepage.png',
    faqs: () => [
      {
        question: 'តើ E-School Cambodia ជាអ្វី?',
        answer:
          'E-School Cambodia គឺជាគេហទំព័រសម្រាប់រៀនបន្ថែមត្រៀមប្រឡងបាក់ឌុប និងរៀនបំប៉នចំណេះដឹងទូទៅតាមអនឡាញឈានមុខគេនៅក្នុងប្រទេសកម្ពុជា។',
      },
      {
        question: 'តើខ្ញុំអាចសិក្សានៅលើ E-School Cambodia ដោយរបៀបណា?',
        answer:
          'អ្នកអាចសិក្សាបានយ៉ាងងាយស្រួលតាមរយៈការចូលទៅកាន់វេបសាយ ទាញយកកម្មវិធីទូរស័ព្ទរបស់ E-School Cambodia ទាំងលើ iOS និង Android ឬ Computer។',
      },
      {
        question: 'តើមានមុខវិជ្ជាអ្វីខ្លះសម្រាប់ថ្នាក់ទី ១២?',
        answer:
          'យើងមានមុខវិជ្ជាសំខាន់ៗដូចជា គណិតវិទ្យា រូបវិទ្យា គីមីវិទ្យា ជីវវិទ្យា និងអក្សរសាស្ត្រខ្មែរ ដែលបង្រៀនដោយលោកគ្រូ-អ្នកគ្រូដែលមានបទពិសោធន៍ខ្ពស់។',
      },
    ],
  },

  // 2. Download Page SEO & FAQs
  download: {
    titleKey: 'download.seo.title',
    ogTitleKey: 'download.seo.title',
    descriptionKey: 'download.seo.desc',
    ogDescriptionKey: 'download.seo.desc',
    ogImage: '/img/download.png',
    faqs: (t) => [
      {
        question: t('download.faq.q1'),
        answer: t('download.faq.a1'),
      },
      {
        question: t('download.faq.q2'),
        answer: t('download.faq.a2'),
      },
      {
        question: t('download.faq.q3'),
        answer: t('download.faq.a3'),
      },
    ],
  },

  // 3. Contact Page SEO & FAQs
  contact: {
    titleKey: 'contact.seo.title',
    ogTitleKey: 'contact.seo.title',
    descriptionKey: 'contact.seo.desc',
    ogDescriptionKey: 'contact.seo.desc',
    ogImage: '/img/contact.png',
    faqs: (t) => [
      {
        question: t('contact.faq.q1'),
        answer: t('contact.faq.a1'),
      },
      {
        question: t('contact.faq.q2'),
        answer: t('contact.faq.a2'),
      },
      {
        question: t('contact.faq.q3'),
        answer: t('contact.faq.a3'),
      },
    ],
  },
} satisfies Record<string, PageSeoConfig>;
